import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTags = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "Label"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M14.559,23.687c-0.601,0-1.166-0.234-1.591-0.658L1.407,11.467c-0.708-0.709-1.098-1.65-1.098-2.651V2.559 c0-1.241,1.009-2.25,2.25-2.25h6.257c1.001,0,1.943,0.39,2.651,1.098l11.561,11.561c0.877,0.877,0.877,2.304,0,3.182l-6.879,6.88 C15.725,23.454,15.16,23.687,14.559,23.687z M2.559,1.809c-0.414,0-0.75,0.336-0.75,0.75v6.257c0,0.601,0.234,1.166,0.659,1.591 l11.561,11.562c0.141,0.141,0.329,0.219,0.53,0.219s0.389-0.078,0.53-0.219l6.879-6.88c0.292-0.292,0.292-0.768,0-1.061 L10.407,2.467c-0.425-0.424-0.99-0.658-1.59-0.658H2.559z" }), /* @__PURE__ */ _jsx("path", { d: "M6.309,8.559c-1.241,0-2.25-1.009-2.25-2.25s1.009-2.25,2.25-2.25s2.25,1.009,2.25,2.25S7.55,8.559,6.309,8.559z  M6.309,5.559c-0.414,0-0.75,0.336-0.75,0.75s0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75S6.723,5.559,6.309,5.559z" })] })]
});
const ForwardRef = forwardRef(SvgTags);
export default ForwardRef;
